// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zELlU0vuf2QyBIZpkTr_ {
  --top-header-height: 4.5rem;

  position: relative;
  min-height: var(--top-header-height);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2.5rem 4.0625rem 1rem;
}

.qh3fJGspSjJ9H6QeZ_kw {
  --top-header-height: 4.5rem;
  --top-margin: 5vh;

  width: 32.8125rem;
  height: auto;
  margin: auto;
  border-radius: 0.75rem;
  max-height: calc(100% - 2 * var(--top-margin));
}

.Jf5JSC79L5L2ojlXlNwO {
  max-height: 75vh;
  padding: 0 2.5rem;
}

.XbfQznsK9ZRmAaY2Ulko {
  width: 100%;
  height: 100%;
}

.QlvmhmAbC1cSF5Polnx9 {
  width: 1.5rem;
  height: 1.5rem;
}

@media only screen and
  (max-width: 639px) {
  .qh3fJGspSjJ9H6QeZ_kw {
    --top-header-height: 4.0625rem;
    --top-margin: 1.5rem;

    height: 100%;
    max-height: unset;
    margin-top: 1.5625rem;
    width: 100%;
  }

  .zELlU0vuf2QyBIZpkTr_ {
    --top-header-height: 4.0625rem;

    padding: 1.25rem 4.0625rem;
  }

  .Jf5JSC79L5L2ojlXlNwO {
    height: calc(100% - var(--top-header-height));
    padding: 0 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NarrowModal/NarrowModal.module.css"],"names":[],"mappings":"AAAA;EACE,2BAAyB;;EAEzB,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAAuB;AACzB;;AAEA;EACE,2BAAyB;EACzB,iBAAiB;;EAEjB,iBAAY;EACZ,YAAY;EACZ,YAAY;EACZ,sBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAW;EACX,cAAY;AACd;;AAEA;;EACE;IACE,8BAAyB;IACzB,oBAAkB;;IAElB,YAAY;IACZ,iBAAiB;IACjB,qBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,8BAAyB;;IAEzB,0BAAkB;EACpB;;EAEA;IACE,6CAA6C;IAC7C,eAAe;EACjB;AACF","sourcesContent":[".modalHeader {\n  --top-header-height: 72px;\n\n  position: relative;\n  min-height: var(--top-header-height);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 65px 16px;\n}\n\n.modalContentWrapper {\n  --top-header-height: 72px;\n  --top-margin: 5vh;\n\n  width: 525px;\n  height: auto;\n  margin: auto;\n  border-radius: 12px;\n  max-height: calc(100% - 2 * var(--top-margin));\n}\n\n.modalContent {\n  max-height: 75vh;\n  padding: 0 40px;\n}\n\n.modalChildren {\n  width: 100%;\n  height: 100%;\n}\n\n.backBtn {\n  width: 24px;\n  height: 24px;\n}\n\n@media (--mobile) {\n  .modalContentWrapper {\n    --top-header-height: 65px;\n    --top-margin: 24px;\n\n    height: 100%;\n    max-height: unset;\n    margin-top: 25px;\n    width: 100%;\n  }\n\n  .modalHeader {\n    --top-header-height: 65px;\n\n    padding: 20px 65px;\n  }\n\n  .modalContent {\n    height: calc(100% - var(--top-header-height));\n    padding: 0 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalHeader": `zELlU0vuf2QyBIZpkTr_`,
	"modalContentWrapper": `qh3fJGspSjJ9H6QeZ_kw`,
	"modalContent": `Jf5JSC79L5L2ojlXlNwO`,
	"modalChildren": `XbfQznsK9ZRmAaY2Ulko`,
	"backBtn": `QlvmhmAbC1cSF5Polnx9`
};
export default ___CSS_LOADER_EXPORT___;
